import { createSelector } from "reselect";
import { SignalRNotification } from "src/globalTypes";
import { RootState as RS } from "../types";
import { NotificationsSlice } from "./reducer";
import { getMappingNotifications } from "./system/selectors";
import { getSystemAdminNotifications } from "./systemAdmin/selectors";
import { getTemplateNonTaskNotificationMessages } from "./template/selectors";
import { getSystemNotificationIdsToResolve } from "./utils";

export * from "./system/selectors";
export * from "./template/selectors";

export const getNotificationsSlice = (s: RS): NotificationsSlice =>
  s.notifications;

const getNotificationId = (s: RS, notificationId: number) => notificationId;

const getNotificationIdsToResolve = createSelector(
  getMappingNotifications,
  getTemplateNonTaskNotificationMessages,
  getSystemAdminNotifications,
  getNotificationId,
  (
    systemNotifications,
    templateNotifications,
    systemAdminNotifications,
    notificationId
  ) => {
    const findMsg = (notification: SignalRNotification) =>
      notification.notificationId === notificationId;

    const systemNotfication = systemNotifications.find(findMsg);
    const templateNotification = templateNotifications.find(findMsg);
    const systemAdminNotification = systemAdminNotifications.find(findMsg);

    if (systemNotfication) {
      return getSystemNotificationIdsToResolve(
        systemNotifications,
        systemNotfication.datasourceId
      );
    }

    if (templateNotification || systemAdminNotification) {
      return [notificationId];
    }

    return [];
  }
);

export const getNotificationIdsToResolveForIds = (
  state: RS,
  notificationIds: number[]
) =>
  notificationIds
    .map((notificationId) => getNotificationIdsToResolve(state, notificationId))
    .flat();
